/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionStage } from '../../models/submission-stage';
import { UpdateProjectItemSubmittalCommandResult } from '../../models/update-project-item-submittal-command-result';
import { VendorDataForUpdateVm } from '../../models/vendor-data-for-update-vm';

export interface ApiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Plain$Params {
      body?: {
'Id'?: string;
'ProjectId'?: string;
'SubmittalDate'?: string;
'SubmittalTitle'?: string;
'SubmissionStage'?: SubmissionStage;
'ParentId'?: string;
'ProjectItemIds'?: Array<string>;
'Vendors'?: Array<VendorDataForUpdateVm>;
}
}

export function apiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectItemSubmittalCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectItemSubmittalCommandResult>;
    })
  );
}

apiProjectItemSubmittalsUpdateProjectItemSubmittalPatch$Plain.PATH = '/api/ProjectItemSubmittals/UpdateProjectItemSubmittal';
